// @flow

/**
 * index.js - точка входа для приложения
 * @module index
 * @requires module:config
 * @requires module:containers/Dashboard
 * @requires module:containers/Page
 * @requires module:containers/About
 * @requires module:store/configureStore
 * */

import React from 'react'
import ReactDOM from 'react-dom'
import {Route} from 'react-router'
import {Provider} from 'react-redux'

import createHistory from 'history/createBrowserHistory'

import {ConnectedRouter, routerMiddleware} from 'react-router-redux'

import './index.css'

import configureStore from './store/configureStore'
import {APP_ROOT, routes} from './config'

// не имеет смысла без https
// import registerServiceWorker from './registerServiceWorker'

const history = createHistory({
    basename: APP_ROOT
})
const middleware = routerMiddleware(history)
const store = configureStore({}, middleware)

ReactDOM.render(
<Provider store={store}>
    <ConnectedRouter history={history}>
        <React.Fragment>
            {routes.map((props, i) => {
                return (
                    <Route key={i} {...props}/>
                )
            })}
        </React.Fragment>
    </ConnectedRouter>
</Provider>,
document.getElementById('root')
)

// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js